@use '@ingka/text/_mixins.scss' as text;
@use '@ingka/svg-icon/_mixins.scss' as svgIcon;
@use '@ingka/switch/_mixins.scss' as switch;
@use '@ingka/forms/_mixins.scss' as forms;
@use '@ingka/aspect-ratio-box/_mixins.scss' as aspectRatioBox;
@use '@ingka/image/_mixins.scss' as image;
@use '@ingka/list-view/_mixins.scss' as listView;
@use '@ingka/focus/_mixins.scss' as focus;
@use '@ingka/member-card/_mixins.scss' as memberCard;

@use '@ingka/base/_mixins.scss' as *;
@use '@ingka/loading/_mixins.scss' as *;
@use './constants.scss' as *;

@include text.text($prefix);
@include svgIcon.svg-icon($prefix);
@include forms.checkbox($prefix);
@include focus.checkbox-focus($prefix);
@include switch.switch($prefix);
@include focus.switch-focus($prefix);
@include forms.radio($prefix);
@include focus.radio-focus($prefix);
@include aspectRatioBox.aspect-ratio-box($prefix);
@include image.image($prefix);
@include listView.list-view($prefix);
@include focus.list-view-focus($prefix);

@include memberCard.member-card($prefix);
@include memberCard.member-card-vertical($prefix);

@include loading($prefix);
